import { render, staticRenderFns } from "./YiLianDBFWContract.vue?vue&type=template&id=8183188c&scoped=true"
import script from "./YiLianDBFWContract.vue?vue&type=script&lang=js"
export * from "./YiLianDBFWContract.vue?vue&type=script&lang=js"
import style0 from "./YiLianDBFWContract.vue?vue&type=style&index=0&id=8183188c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8183188c",
  null
  
)

export default component.exports